import { useState } from "react";
import { Loader2, CheckCircle2 } from "lucide-react";
import { toast } from "sonner";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { publicApi, errMsg } from "@/lib/api";

const profile = () => JSON.parse(localStorage.getItem("vp_visitor") || "null") || {};

export const ContactForm = ({ path, cta, done, guests = false, onDone, testPrefix }) => {
  const p = profile();
  const [f, setF] = useState({ name: p.nickname || p.name || "", mobile: p.mobile || "", email: p.email || "", guests: 0 });
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    if (!f.name.trim() || !f.mobile.trim()) return toast.error("Please share your name and mobile number");
    setBusy(true);
    try {
      const body = { name: f.name, mobile: f.mobile, email: f.email, ...(guests ? { guests: Number(f.guests) || 0, visitor_id: p.id || "" } : {}) };
      const { data } = await publicApi.post(path, body);
      setSent(true); onDone?.(data);
    } catch (err) { toast.error(errMsg(err)); } finally { setBusy(false); }
  };
  if (sent) return <p className="flex items-start gap-2 rounded-2xl bg-emerald-50 p-4 text-sm text-emerald-800" data-testid={`${testPrefix}-success`}><CheckCircle2 className="mt-0.5 h-4 w-4 shrink-0" />{done}</p>;
  return (
    <form onSubmit={submit} className="space-y-2" data-testid={`${testPrefix}-form`}>
      <Input value={f.name} onChange={(e) => setF({ ...f, name: e.target.value })} placeholder="Your name" data-testid={`${testPrefix}-name`} />
      <Input value={f.mobile} onChange={(e) => setF({ ...f, mobile: e.target.value })} placeholder="Mobile number" inputMode="tel" data-testid={`${testPrefix}-mobile`} />
      <Input type="email" value={f.email} onChange={(e) => setF({ ...f, email: e.target.value })} placeholder={guests ? "Email (for a reminder the day before)" : "Email (optional)"} data-testid={`${testPrefix}-email`} />
      {guests && (
        <label className="flex items-center justify-between gap-3 text-sm text-slate-600">Bringing guests?
          <Input type="number" min={0} max={20} value={f.guests} onChange={(e) => setF({ ...f, guests: e.target.value })} className="w-24" data-testid={`${testPrefix}-guests`} />
        </label>
      )}
      <Button type="submit" disabled={busy} className="w-full rounded-full bg-[#0A3A6B] hover:bg-[#1D64B4]" data-testid={`${testPrefix}-submit`}>{busy && <Loader2 className="mr-2 h-4 w-4 animate-spin" />}{cta}</Button>
    </form>
  );
};
